import { ZCatalog } from "src/business/catalog/ZCatalog";
import { loadStepSchemes } from "src/business/workflow/apiWorkflow";
import { ZWorkflowCard } from "src/business/workflow/ZWorkflowCard";
import { ZWorkflowStep } from "src/business/workflow/ZWorkflowStep";
import { ZMfNode } from "src/components/MForm/ZMfNode";

import { CDSFormStoreLoader } from "./CDSFormStore";
import { extractClassIdsFromFieldsValue } from "./extractClassIdsFromFieldsValue";
import { extractClassIdsFromRecord } from "./extractClassIdsFromRecord";
import { makeRecordForm } from "./makeRecordForm";

const createOriginalCardNode = (catalogId: string): ZMfNode => ({
  type: "attr",
  attr: {
    uid: "",
    displayId: 0,
    name: "originalCard",
    title: "Исходная запись",
    type: { name: "strOption", role: "record" },
    edit: {
      component: {
        type: "RecordSelect",
        catalogId,
      },
      colSpan: 1,
    },
  },
  disableIf: { type: "true" },
});

export type WorkflowRecordFormContext = {
  step: ZWorkflowStep;
  record?: ZWorkflowCard;
};

export const createWorkflowRecordFormLoader = (
  catalog: ZCatalog,
): CDSFormStoreLoader<WorkflowRecordFormContext> => ({
  async load({ step, record }, currentValues) {
    const classIds = currentValues
      ? extractClassIdsFromFieldsValue(currentValues as Record<string, unknown>)
      : extractClassIdsFromRecord(record);
    const schemes = await loadStepSchemes(step.id, classIds);
    const info = makeRecordForm(
      schemes,
      catalog.classifiers ?? [],
      record,
      record
        ? {
            nodes: [createOriginalCardNode(record.catalogId ?? catalog.id)],
            data: { originalCard: record.originalCard ?? null },
          }
        : undefined,
    );

    return { info, schemes };
  },
});
